// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2124n","consentsList":"PatientConsents_consentsList__1FSsf","consentsListEmpty":"PatientConsents_consentsListEmpty__16sM5"};